import { Injectable } from '@angular/core';
import { ServiceCallUtilsService } from '../service-call-utils.service';

@Injectable({
  providedIn: 'root'
})
export class SignatureService {

  constructor(private serviceCallUtilsService: ServiceCallUtilsService) { }
  
  getPdf(jsonFile){
    return this.serviceCallUtilsService
      .callPostWebService('/PortabilityControllerRESTService/generateReportPortabilityToPDF',
      jsonFile);
  }
}
